import styled from "styled-components";

import { fontSizes } from "../../shared/styles/typography";

export const Article = styled.article`
  background: ${({ theme }) => theme.colors.card};
  border-radius: ${({ theme }) => theme.layout.radiusLg};
  box-shadow: ${({ theme }) => theme.shadows.card};
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  transition: transform 0.2s, box-shadow 0.2s;
  border: 1px solid ${({ theme }) => theme.colors.border};

  &:hover {
    transform: translateY(-3px);
    box-shadow: ${({ theme }) => theme.shadows.cardHover};
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export const Avatar = styled.img`
  width: 5.2rem;
  height: 5.2rem;
  border-radius: ${({ theme }) => theme.layout.radiusMd};
  object-fit: cover;
  flex-shrink: 0;
  background: ${({ theme }) => theme.colors.teacherAvatarBg};
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 0;
`;

export const Name = styled.strong`
  font-size: ${fontSizes.base}px;
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.tableHeaderText};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Subject = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: ${fontSizes.sm}px;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  background: ${({ theme }) => theme.colors.teacherChipBg};
  padding: 2px 8px;
  border-radius: 20px;
  width: fit-content;
`;

export const Email = styled.span`
  font-size: ${fontSizes.sm}px;
  color: ${({ theme }) => theme.colors.teacherMeta};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Bio = styled.p`
  font-size: ${fontSizes.base}px;
  color: ${({ theme }) => theme.colors.teacherBio};
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
`;

export const Schedule = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-top: 0.4rem;
`;

export const ScheduleChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: ${fontSizes.sm}px;
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.teacherScheduleText};
  background: ${({ theme }) => theme.colors.teacherScheduleBg};
  border: 1px solid ${({ theme }) => theme.colors.teacherScheduleBorder};
  border-radius: 20px;
  padding: 4px 10px;
`;

export const Cta = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  width: 100%;
  padding: 1rem;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.whatsappGreen},
    ${({ theme }) => theme.colors.whatsappGreenDark}
  );
  color: ${({ theme }) => theme.colors.titleOnPrimary};
  font-size: ${fontSizes.base}px;
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  border-radius: 10px;
  text-decoration: none;
  margin-top: auto;
  transition: opacity 0.2s, transform 0.2s;

  &:hover {
    opacity: 0.88;
    transform: translateY(-1px);
    color: ${({ theme }) => theme.colors.titleOnPrimary};
  }
`;
